module.exports = __webpack_public_path__ + "img/wheel.fc66c9dc.svg";